import Platform from "../../../../libs/utility/Platform";

export default {
    popupStyles: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    popupoOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 11,
    },
    popupChildrenStyles: {
        maxHeight: "unset",
        height: "100%",
        overflowY: "auto",
        display: "flex",
    },
    intermediaryParentContainer: {
        width: "100%",
        padding: "20px 20px 0px 20px",
        flex: "1 1 0%"
    },
    container: {
        display: "flex",
        flexDirection: "column",
        paddingBottom: "30px",
        width: Platform.isMobileView() ? "100%" : "60%",
    },
    headingRow: {
        display: "flex",
    },
    formRow: {
        display: "flex",
        columnGap: "40px"
    },
    fieldContainer: {
        width: "60%"
    },
    fieldRow: {
        marginTop: "15px",
    },
    submitButtonRow: {
        textAlign: "center",
        marginTop: "30px"
    },
    submitButton: {
        padding: "5px 25px",
    },
}